import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'i2g-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressSpinnerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
